import { loadYouTubeIframeAPI } from "../vendor/youtube-api";

(function ($) {

    // YouTube
    var youtubePlayers = [];
    function getYouTubeVideoId(link) {
        var regExp = /^.*(youtu\.be\/|v\/|e\/|u\/\w+\/|embed\/|v=|vi=|vnd\.youtube\.)([^#\&\?]*).*/;
        var match = link.match(regExp);

        if (match && match[2].length === 11) {
            return match[2];
        } else {
            // Handle invalid YouTube video link
            console.error("Invalid YouTube video link:", link);
            return null;
        }
    }

    // Store the currently playing YouTube video instance
    var currentYoutubePlayer = null;

    loadYouTubeIframeAPI().then((YT) => {
        onYouTubeIframeAPIReady(YT);
    }).catch((error) => {
        console.error("Failed to load YouTube IFrame API:", error);
    });
    function onYouTubeIframeAPIReady(YT) {
        $(".youtube").each(function () {
            var $this = $(this);
            var videoLink = $this.data("video-link");

            // Get YouTube Video ID from the video link
            var videoId = getYouTubeVideoId(videoLink);

            if (videoId) {
                // Based on the YouTube ID, we can easily find the thumbnail image
                $this.css("background-image", "url(http://i.ytimg.com/vi/" + videoId + "/sddefault.jpg)");

                // Overlay the Play icon to make it look like a video player
                var playOverlay = $("<div/>", {"class": "play"});
                $this.append(playOverlay);

                // Attach click event
                $this.on("click", function () {
                    // Pause the currently playing video, if any
                    if (currentYoutubePlayer) {
                        currentYoutubePlayer.pauseVideo();
                    }

                    // Create a new YT.Player instance
                    currentYoutubePlayer = new YT.Player($this[0], {
                        videoId: videoId,
                        playerVars: {
                            autoplay: 1,
                            autohide: 1
                            // Add any other playerVars as needed
                        },
                        events: {
                            "onStateChange": onPlayerStateChange
                        }
                    });
                    youtubePlayers.push(currentYoutubePlayer);

                    // Add a class to mark that the iframe has been loaded
                    $this.addClass("iframe-loaded");
                });
            } else {
                console.log("ERROR");
            }
        });

        function onPlayerStateChange(event) {
            const playing = YT.PlayerState.PLAYING;
            if (event.data === playing) {
                for (const player of youtubePlayers) {
                    if (player !== event.target && player.getPlayerState() === playing) {
                        player.stopVideo();
                    }
                }
            }
        }
    }


    // video file
    const video = document.getElementById('myVideoFile');
    const button = document.getElementById('playButtonFile');
    if (video && button) {
        button.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                button.style.display = 'none';
            }
        });
    }

})(jQuery);